import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { getImageUrlWithSize } from '@common/Utility/common-utils';
import RightSideBar from '../RightSideBar/RightSideBar';
import { BundleOfferSideBarStyled } from './BundleOfferSideBarStyled';
import { BUNDLEOFFER, BUNDLE, PRODUCTICON } from '../../Assets/images';
import { dataLayerSendEvent } from '../BookAppointment/BookingFunnelAnalytics';
import { sendEventToSmartLook } from '@common/Utility/smartlook';
import { getProductItemObjectEventFillers } from 'Epharmacy/EpharmacyAnalytics';

const BundleOfferSideBar = (props) => {
  const router = useRouter();
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedBundle, setSelectedBundle] = useState(false);
  const [handleclose, setHandleclose] = useState(true);
  const [quantity, setQuantity] = useState(null);
  const [sellingPrice, setSellingPrice] = useState(null);
  const [discountPercentage, setDiscountPercentage] = useState(null);
  const [originalPrice, setOriginalPrice] = useState(null);
  const [amountSaved, setAmountSaved] = useState(null);
  const [afterBundle, setafterBundle] = useState(false);
  const [primaryClicked, setprimaryClicked] = useState(false);
  const bundles = props?.BundleDetails?.bundles;

useEffect(() => {
  if (props?.showBundleSidebar) {
    dataLayerSendEvent('upselling_popup_viewed', {
      type:'bundle deal',
      screen_name: props?.screenName,
      page_type: props?.pageType.toLowerCase(),
      page_id: props?.pageId ? props?.pageId : null,
      myaster_category: 'epharmacy',
      product_sku: props?.sku,
      product_name: props?.productName,
    });
    sendEventToSmartLook('upselling_popup_viewed');

  }
}, [props?.showBundleSidebar]);

const bundleAddToCartEvent = (quantity, discountPercentage, amountSaved, sellingPrice) => {
  const asterBadge = props?.product?.badgeDetails?.asterBadge;
  const lowestPriceLabel = props?.product?.lowestPriceLabel;

  let badgeContents = [];

  if (Array.isArray(asterBadge)) {
    badgeContents = asterBadge?.map((badge) => badge.content);
  } else if (asterBadge) {
    badgeContents = [asterBadge.content];
  }

  const formattedLowestPriceLabel = lowestPriceLabel?.replace(/<\/?b>/g, '');
  if (formattedLowestPriceLabel) {
    badgeContents.push(formattedLowestPriceLabel);
  }
  dataLayerSendEvent('add_to_cart', {
    ecommerce: {
      items: props?.product
        ? [{ ...getProductItemObjectEventFillers(props?.product), quantity: quantity, index: props?.index + 1 }]
        : [],
    },
    section_name:
      props?.sectionName === 'Product Details Page - FBT' || props?.sectionName === 'Product Listing page'
        ? null
        : props?.sectionName,
    screen_name: props?.screenName,
    page_type: props?.pageType.toLowerCase(),
    page_id: props?.pageId ? props?.pageId : null,
    bundle_name: `Pack of ${quantity} items - ${discountPercentage}% OFF!`,
    total_discount: amountSaved,
    currency: 'AED',
    delivery_promise: props?.product?.deliverByV2 || props?.product?.deliverBy || null,
    availability: props?.product?.outOfStock ? 'out of stock' : 'in stock',
    express_availability: props?.product?.express_bool || props?.product?.express ? true : false,
    value: sellingPrice,
    promotion_name: badgeContents?.length > 0 ? badgeContents : null,
    promotion_value_tag: props?.product?.badgeDetails?.offerBadge
      ? `${props?.product?.badgeDetails?.offerBadge}% Off!`
      : null,
    bundle_deal_availability: props?.product?.isBundled ? true : false,
    referrer_page: props?.referrerpage,
    myaster_category: 'epharmacy',
  });
  sendEventToSmartLook('add_to_cart');
};
 

  useEffect(() => {
    if (props?.valueDropDown && bundles) {
      const valueDropDownNumber = parseInt(props.valueDropDown);
      const bundlequantity=bundles?.map(bundle => bundle.quantity)
      if(bundlequantity.includes(valueDropDownNumber)){
        const selectedIndex = bundlequantity.indexOf(valueDropDownNumber);
        if (selectedIndex !== -1) {
          setSelectedCard(selectedIndex);
          setSelectedBundle(true);
          setQuantity(bundles[selectedIndex].quantity);
          setSellingPrice(bundles[selectedIndex].sellingPrice);
          setDiscountPercentage(bundles[selectedIndex].discountPercentage);
          setAmountSaved(bundles[selectedIndex].amountSaved)
        }
      }
    }
  }, [props?.valueDropDown, bundles,props?.productDetails]);
  const handleCardClick = (cardId) => {
    setSelectedCard(cardId);
    setSelectedBundle(true);
    setQuantity(bundles[cardId].quantity);
    setSellingPrice(bundles[cardId].sellingPrice);
    setDiscountPercentage(bundles[cardId]?.discountPercentage)
    setOriginalPrice(bundles[cardId]?.originalPrice)
    setAmountSaved(bundles[cardId]?.amountSaved)
  };
  props?.setcloseBundle(afterBundle);

  return (
    <>
      <div className="BundleOfferSideBarWrap">
        <BundleOfferSideBarStyled>
          {true && handleclose &&(
            <RightSideBar
              modalTitle={'Add more and pay less 🎉'}
              size="md"
              setafterBundle={setafterBundle}
              noFooter
              maxDiscount={props?.BundleDetails?.maxDiscountPercentage}
              footerBtnFullWidth
              isPrimaryButtonDisabled={false}
              primaryButton="Add to Cart"
              closeButton
              isBundleoffer={true}
              isshowUpselling={false}
              footerEnable={selectedBundle ? true : false}
              customClass="bundeldeal"
              messagePrefix={'messagePrefix'}
              name={'name'}
              primaryClicked={primaryClicked}
              isPromotionCart={true}
              isBundleSideBar={true}
              quantity={quantity}
              sellingPrice={sellingPrice}
              primaryButtonClicked={() => {
                if (quantity) {
                  props?.setBundleOffer(quantity);
                  props?.setfromBundleComponent(true);
                  setHandleclose(false);
                  props?.setBundleAddToCart(true);
                  bundleAddToCartEvent(quantity, discountPercentage, amountSaved, sellingPrice);
                }
              }}
              handleClose={() => {
                dataLayerSendEvent('upselling_popup_dismissed', {
                  type: 'bundle deal',
                  screen_name: props?.screenName,
                  page_type: props?.pageType?.toLowerCase(),
                  page_id: props?.pageId,
                  myaster_category: 'epharmacy',
                  product_sku: props?.sku,
                  product_name: props?.productName,
                });
                sendEventToSmartLook('upselling_popup_dismissed');
              }}
            >
              <div className="cardswrapper">
                {bundles?.map((bundle, index) => (
                  <div
                    key={index}
                    className={` ${selectedCard === index ? 'bundlecardgreen' : 'bundlecard'}`}
                    onClick={() => handleCardClick(index)}
                  >
                    <div className="ima">
                      <Image src={getImageUrlWithSize(props?.BundleImage, 32, 32)} alt={'bundle_image'} width={32} height={32} />
                      <div className="title">
                        <div className={` ${selectedCard === index ? 'headp-selected' : 'headp'}`}>
                          {selectedCard === index ? (
                            <span>
                              Pack of {bundle.quantity} items{' '}
                              <span className="percentagegreen">{bundle.discountPercentage}% OFF! </span>{' '}
                            </span>
                          ) : (
                            <span>
                              Pack of {bundle.quantity} items - {bundle.discountPercentage}% OFF!{' '}
                            </span>
                          )}
                        </div>
                        <div className={`${selectedCard === index ? 'subp-selected' : 'subp'}`}>
                          {selectedCard === index ? (
                            <span>
                              🥳 Congratulations! You save <strong> AED {bundle.amountSaved}</strong>
                            </span>
                          ) : (
                            <span>You save AED {bundle.amountSaved}</span>
                          )}
                        </div>
                      </div>
                    </div>
                    {selectedCard === index && (
                      <div className="imageicon">
                        <Image src={BUNDLE} width={32} height={32} />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </RightSideBar>
          )}
        </BundleOfferSideBarStyled>
      </div>
    </>
  );
};

export default BundleOfferSideBar;
